import React from 'react';

export const CircleStarIcon = ({ className, title = 'Community' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" className={className}>
    <title>{title}</title>
    <circle cx="6" cy="6" r="6" fill="#5246F5"/>
    <path d="M6.0002 1.19995L7.17389 4.38451L10.5653 4.51667L7.89927 6.617L8.82156 9.88323L6.0002 7.99675L3.17883 9.88323L4.10113 6.617L1.43512 4.51667L4.82651 4.38451L6.0002 1.19995Z" fill="white"/>
  </svg>
);
